import { Button } from 'antd'
import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from '../payment-section.module.scss'

type PaymentSubscriptionTypeProps = {
  initialState?: boolean
  monthlyPrice: number | null | string
  onStateChange: (state: boolean) => void
  needCustomPlan?: boolean
  employeesSlots?: { min: string; max: string }
}

export const MonthlySubscription: React.FC<PaymentSubscriptionTypeProps> = ({
  initialState,
  onStateChange,
  monthlyPrice,
  needCustomPlan,
  employeesSlots,
}) => {
  const { t } = useTranslation()

  return (
    <div
      className={clsx(
        { [styles.active]: initialState },
        { [styles.active]: needCustomPlan },
        styles.subscription,
        'cursor-pointer row flex justify-content-between bg-white pb-5 mb-5 rounded-4 col-12 col-md-6',
      )}
      onClick={() => onStateChange(!initialState)}
    >
      <div className={clsx(styles.paymentType, 'position-relative w-auto start-100 p-3')}>{t('onboarding.payment.subscription.monthly')}</div>
      <div className={clsx(styles.price, 'd-flex ps-0 mb-3')}>
        <div className="lh-sm">
          <div className="d-flex align-items-center">
            {needCustomPlan ? (
              <Button type="primary">{t('onboarding.payment.connectSalesButton')}</Button>
            ) : (
              <>
                <div className="h1 me-2">{monthlyPrice} ₽/</div>
                <div className="h6">{t('onboarding.payment.perMonth')}</div>
              </>
            )}
          </div>
        </div>
      </div>
      <div className="px-5">
        <div className="d-flex flex-nowrap justify-content-between">
          <p>{t('onboarding.payment.projects.projects')}</p>
          <p className="fw-bold">{t('onboarding.payment.projects.projectsAmount')}</p>
        </div>
        <div className="d-flex flex-nowrap justify-content-between">
          <p>{t('onboarding.payment.projects.employeesSlots')}</p>
          <p className="fw-bold">{!needCustomPlan ? `${employeesSlots?.min}-${employeesSlots?.max}` : '50+'}</p>
        </div>
      </div>
    </div>
  )
}
